import React from 'react';
import styled from 'styled-components';

import { Flex } from 'components/flex';
import ConditionalLink from 'components/conditionalLink';

interface TabsProps {
  items: {
    label: string;
    link: string;
    active: boolean;
    disabled?: boolean;
    hide?: boolean;
  }[];
}

const TabButton = styled(ConditionalLink)`
  display: flex;
  background: transparent;
  align-items: center;
  border: 0;
  border-top: 3px solid transparent;
  border-bottom: 3px solid
    ${(props: any) => (props['data-active'] ? props.theme.colors.green3 : 'transparent')};
  padding: 0 20px;
  margin: 0 10px;
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  color: ${(props: any) =>
    props['data-disabled'] ? props.theme.colors.light4 : props.theme.colors.gray3};
  white-space: nowrap;
`;

const Tabs = ({ items }: TabsProps) => {
  return (
    <Flex height={57} alignItems="stretch" flexWrap="nowrap">
      {items
        .filter((item) => !item.hide)
        .map((item, index) => {
          return (
            <TabButton
              key={`${item.label}-${index.toString()}`}
              to={item.link}
              data-active={item.active}
              data-disabled={item.disabled}
              component={Flex}
              type={item.disabled ? 'nolink' : 'internal'}
            >
              {item.label}
            </TabButton>
          );
        })}
    </Flex>
  );
};

export default Tabs;
